import type { ICellRendererParams } from 'ag-grid-community';
import { SensitivityContainer } from 'components/Blotters/sensitivity/sensitivity';
import { Component } from 'react';

interface Data {
  referenceQuoteId: string;
}
interface Value {
  id: string;
}
/**
 * This is a class component because there doesn't seem to be a solution to tell AG-Grid not to discard the details component on each render
 */
export class SensitivityDetailCellRenderer extends Component<ICellRendererParams<Data, Value>> {
  constructor(props: ICellRendererParams<Data, Value>) {
    super(props);
  }

  refresh(_params: unknown) {
    return true;
  }

  render() {
    return (
      <SensitivityContainer className="w-100" paddingLeft={80} referenceQuoteId={this.props.data?.referenceQuoteId!} />
    );
  }
}
